/* eslint-disable @typescript-eslint/no-explicit-any */
import { useSaveSubscription } from "@/api/clientApi/front";
import { LocalStorageKey } from "@/constants/constants";
import { deviceInfo } from "@/stores/deviceStore";

import { getLocalStorageItem, setLocalStorageItem } from "./localStorage";

let web_push_public_key = "";
export function updateWebPushPublicKey(val: string) {
  if (web_push_public_key != val) {
    setTimeout(() => {
      subscribeUser();
    }, 500);
  }
  web_push_public_key = val;
}
function urlB64ToUint8Array(base64String: string) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export function subscribeUser(source = "auto") {
  if (!window.swRegistration?.pushManager || !web_push_public_key) {
    console.error("subscription no pushManager");
    return;
  }
  window.swRegistration.pushManager
    .getSubscription()
    .then((subscription: any) => {
      if (!subscription) {
        // 如果用户没有订阅
        const applicationServerKey = urlB64ToUint8Array(web_push_public_key);
        window.swRegistration.pushManager
          .subscribe({
            userVisibleOnly: true,
            applicationServerKey: applicationServerKey,
          })
          // 用户同意
          .then(function (subscription: any) {
            subscribeEnd(subscription, source);
          })
          // 用户不同意或者生成失败
          .catch((err: any) => {
            console.error(err);
            subscribeEnd(null, source);
          });
      } else {
        subscribeEnd(subscription, source, 1);
      }
    });
}

//订阅出结果 source-来源
//status 0-新订阅 1-已有订阅
function subscribeEnd(subscription: any, source: string, status = 0) {
  let sInfo = "";
  if (subscription) {
    sInfo = JSON.stringify(subscription);
    setLocalStorageItem(LocalStorageKey.SubscriptionInfo, sInfo);
  }
  if (status == 1 && source == "auto") {
    //已有的自动订阅
    return;
  }
  if (sInfo) {
    //有订阅
    if (source == "auto") {
      requestSaveSubscription(sInfo);
    } else {
      //   requestActSubscription(1, sInfo)
    }
  } else if (source != "auto") {
    //没有订阅
    // useAppStore().showOrHideSubscribe(true, 3)
  }
}

//普通订阅 上报
export function requestSaveSubscription(sInfo = "") {
  let params: any = null;
  if (!sInfo) {
    const subscriptionInfo = getLocalStorageItem(
      LocalStorageKey.SubscriptionInfo,
      "",
    );
    sInfo =
      typeof subscriptionInfo != "string"
        ? JSON.stringify(subscriptionInfo)
        : subscriptionInfo;
  }
  if (sInfo) {
    //webpush
    params = {
      type: 1,
      subscription: sInfo,
    };
  }
  if (params) {
    params["ua"] = deviceInfo.UA;
    useSaveSubscription(params).then((res) => {});
  }
}
